import { createSelector } from 'reselect';

export const makeGetOnline = () => createSelector([getOnline], online => online);

const getOnline = (state, props) => state.offline.online;
